module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/c80487c920b6bfce6527b34a9d41f95a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Ban.svg
// module id = DDu0
// module chunks = 1